import { useStaticQuery, graphql } from 'gatsby'
import { resolveMicrocopyFromResourcesQueryResultForLocale } from '../../services/microcopyService'

const resourcesQuery = graphql`
  query {
    en: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "en" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    de: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "de" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    nl: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "nl" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    fr: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "fr" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    it: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "it" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    es: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "es" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    enUS: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "en-US" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    cs: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "cs" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    pl: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "pl" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
    pt: allContentfulMicrocopyContainer(
      filter: { node_locale: { eq: "pt" }, key: { eq: "categories" } }
    ) {
      nodes {
        ...CoreMicrocopyFields
      }
    }
  }
`

export const useCategoriesI18n = (locale) => {
  return resolveMicrocopyFromResourcesQueryResultForLocale(useStaticQuery(resourcesQuery), locale)
}
